import AudioRecorder from '../AudioRecorder/AudioRecorder';
import FileSelect from '../FileSelect/FileSelect';
import DeviceAssociationsSection from '../DeviceAssociationsSection/DeviceAssociationsSection';
import AudioLibrarySection from '../AudioLibrarySection/AudioLibrarySection';
import { MAX_RECORD_DURATION_MS } from '../../utils/audioManager.utils';

const AssignByAudioSection = ({
  sectionCardClass,
  isCompactLayout,
  file,
  audioList,
  blob,
  updateFile,
  updateBlob,
  onSaveTemp,
  onPlayTemp,
  selectedAudios,
  canEditDelete,
  onAudioSelectToggle,
  toEdit,
  editName,
  setEditName,
  onEdit,
  onResolveEdit,
  onCancelEdit,
  setToDelete,
  updateAudioList,
  deviceSearchValue,
  setDeviceSearchValue,
  hasSelectedAudio,
  groupedDeviceAssociationOptions,
  selectedDevices,
  canEditDeviceAssociations,
  onToggleAssociatedDevice,
}) => {
  return (
    <>
      <div className="row g-3 g-lg-4 flex-shrink-0">
        <div className="col-12 col-lg-6">
          <div className="rounded-2 border border-secondary border-opacity-50 p-2 p-lg-3 h-100 bg-primary-shadow d-flex flex-column">
            <p className="small text-muted mb-2 text-center">Upload a file</p>
            <FileSelect
              file={file}
              fileTypes={['.mp3', '.au', '.opus', '.vorbis', '.wav']}
              onChange={updateFile}
              maxFileSize={1500000}
              onSave={onSaveTemp}
            />
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="rounded-2 border border-secondary border-opacity-50 p-2 p-lg-3 h-100 bg-primary-shadow d-flex flex-column">
            <p className="small text-muted mb-2 text-center">Record a new clip</p>
            <AudioRecorder
              usedNames={audioList.map((audio) => audio.displayName)}
              maxDuration={MAX_RECORD_DURATION_MS}
              onChange={updateBlob}
              clear={blob === null}
              onPlay={onPlayTemp}
              onSave={onSaveTemp}
            />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column flex-grow-1 min-h-0 gap-3">
        <AudioLibrarySection
          sectionCardClass={sectionCardClass}
          isCompactLayout={isCompactLayout}
          audioList={audioList}
          canEditDelete={canEditDelete}
          selectedAudios={selectedAudios}
          onAudioSelectToggle={onAudioSelectToggle}
          toEdit={toEdit}
          editName={editName}
          setEditName={setEditName}
          onEdit={onEdit}
          onResolveEdit={onResolveEdit}
          onCancelEdit={onCancelEdit}
          setToDelete={setToDelete}
          updateAudioList={updateAudioList}
        />

        <DeviceAssociationsSection
          sectionCardClass={sectionCardClass}
          isCompactLayout={isCompactLayout}
          deviceSearchValue={deviceSearchValue}
          setDeviceSearchValue={setDeviceSearchValue}
          hasSelectedAudio={hasSelectedAudio}
          groupedDeviceAssociationOptions={groupedDeviceAssociationOptions}
          selectedDevices={selectedDevices}
          canEditDeviceAssociations={canEditDeviceAssociations}
          onToggleAssociatedDevice={onToggleAssociatedDevice}
        />
      </div>
    </>
  );
};

export default AssignByAudioSection;
